import { createSlice } from "@reduxjs/toolkit";

// ----------------------------------------------------------------------

const initialState = {
  chipsNumber: [],
};

const slice = createSlice({
  name: "chips",
  initialState,
  reducers: {
    chipsHandlerOnClick(state, action) {
      const maxChipsCount = 10;
      const number = action.payload;
      const chips = state.chipsNumber;
      const index = chips.findIndex((ch) => ch === number);
      if (index === -1) {
        if (chips.length >= maxChipsCount) return;
        state.chipsNumber.push(number);
      } else {
        state.chipsNumber.splice(index, 1);
      }
    },
    clearChips(state, action) {
      state.chipsNumber = [];
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { chipsHandlerOnClick, clearChips } =
  slice.actions;

// ----------------------------------------------------------------------
